import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Products from './components/Products';
import Home from './components/Home';
import Infrastructure from './components/Infrastructure';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import theme from './theme';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import { motion } from 'framer-motion';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import { Box } from '@mui/material';

// Define consistent colors
const themeColors = {
  primary: '#1a472a',
  secondary: '#2e7d32',
  text: '#333333',
  background: '#f5f5f5',
  white: '#ffffff'
};

function App() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            minHeight: '100vh'
          }}
        >
          <header>
            <Navbar />
          </header>
          <main 
            style={{ flex: 1 }}
            role="main"
            aria-label="Main content"
          >
            <Routes>
              <Route path="/" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Home page content"
                >
                  <Home />
                </motion.div>
              } />
              <Route path="/about" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="About us page content"
                >
                  <About />
                </motion.div>
              } />
              <Route path="/contact" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Contact page content"
                >
                  <Contact />
                </motion.div>
              } />
              <Route path="/products" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Products page content"
                >
                  <Products />
                </motion.div>
              } />
              <Route path="/infrastructure" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Infrastructure page content"
                >
                  <Infrastructure />
                </motion.div>
              } />
              <Route path="/privacy-policy" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Privacy policy page content"
                >
                  <PrivacyPolicy />
                </motion.div>
              } />
              <Route path="/terms" element={
                <motion.div 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  role="region"
                  aria-label="Terms of use page content"
                >
                  <TermsOfUse />
                </motion.div>
              } />
            </Routes>
          </main>
          <footer>
            <Footer />
          </footer>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export { themeColors };
export default App;
